// extracted by mini-css-extract-plugin
export default {"container":"JAKUc","disabled":"P523v","avatar":"SQ64M","fakeInput":"yd7PZ","placeholder":"T4QBj"};